var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOrangePay = function SvgOrangePay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 20,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#orangePay_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 20,
    fill: "#fff",
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF5F00",
    d: "M18.354 5.759h-4.706v8.483h4.706z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EB001B",
    d: "M13.947 10a5.4 5.4 0 0 1 2.054-4.241 5.37 5.37 0 0 0-7.881 1.38 5.41 5.41 0 0 0 2.208 7.714 5.36 5.36 0 0 0 5.673-.61A5.38 5.38 0 0 1 13.947 10"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F79E1B",
    d: "M24.7 10a5.4 5.4 0 0 1-.819 2.863 5.4 5.4 0 0 1-2.208 1.99 5.36 5.36 0 0 1-5.673-.61A5.4 5.4 0 0 0 18.054 10 5.41 5.41 0 0 0 16 5.759a5.37 5.37 0 0 1 7.881 1.38c.535.858.82 1.85.82 2.862"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "orangePay_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v20H0z"
  })))));
};
export default SvgOrangePay;